import { Payload, ChatUser } from "./models";
import Primus from "primus-client";
import { ChatEvents, } from "./events";
import { EventEmitter } from "events";
import { RoomCallType, RoomProtocol } from "./protocol";
import RoomClient from "./media/RoomClient";
import thunk from "redux-thunk";
import reducers from "./media/redux/reducers";
import * as cookiesManager from "./media/cookiesManager";
import { v4 as uuid } from "uuid";
import { applyMiddleware as applyReduxMiddleware, createStore as createReduxStore, } from "redux";
const reduxMiddlewares = [thunk];
// import * as faceapi from './protocol/face-api.js';
import deviceInfo from "./media/deviceInfo";
import UrlParse from "url-parse";
export class ChatService {
    constructor(wssUrl, token, signature) {
        this.wssUrl = wssUrl;
        this.token = token;
        this.signature = signature;
        this._user = null;
        this._emitter = null;
        this._mediaRoomClient = null;
        this.socketDataHandler = this.socketDataHandler.bind(this);
        this._emitter = new EventEmitter();
        this._rooms = [];
        const store = createReduxStore(reducers, undefined, applyReduxMiddleware(...reduxMiddlewares));
        window.STORE = store;
        RoomClient.init({ store });
    }
    /**
     *
     * @param event
     * @param listener
     * @returns
     */
    on(event, listener) {
        return this._emitter?.addListener(event, listener);
    }
    /**
     *
     * @param event
     * @param listener
     * @returns
     */
    off(event, listener) {
        return this._emitter?.removeListener(event, listener);
    }
    emit(event, ...args) {
        return this._emitter?.emit(event, ...args);
    }
    /**
     * Init the chat service
     * @param wssUrl
     * @param token
     * @param signature
     * @returns void
     */
    static init(wssUrl, token, signature) {
        if (!this._service)
            this._service = new ChatService(wssUrl, token, signature);
        this._service.connectPrimus();
        return this._service;
    }
    async connectPrimus() {
        this._socket = new Primus(`${this.wssUrl}?token=${this.token}`, {
            transport: {
                headers: {
                    authorization: `Bearer ${this.token}`,
                    "sec-websocket-protocol": "protoo",
                },
            },
        });
        this._socket.on("data", this.socketDataHandler);
        this._socket.on("end", () => {
            console.log("Socked has ended");
        });
    }
    static getInstance() {
        return this._service;
    }
    /***
     *
     */
    async socketDataHandler(data) {
        if (!data.type)
            return;
        if (data.type === ChatEvents.ChatAuthSuccessEvent) {
            let { uuid, name, email } = data.payload.user;
            this._user = new ChatUser(uuid, name, email);
        }
        if (data.type === ChatEvents.RoomJoinedEvent) {
            const roomUid = data.payload.roomUid;
            if (!this._rooms[roomUid]) {
                this._rooms[roomUid] = {
                    roomUid: data.payload.roomUid,
                    partipants: data.payload.participants,
                };
            }
        }
        if (data.type === ChatEvents.RoomTextMessageReceivedEvent) {
            //Message Double Tick Process
            if (data.payload.sender != this._user?.uuid) {
                this.sendInRoomViaSocket(RoomProtocol.TextMessageReceived, data.payload.roomUid, {
                    messageUid: data.payload.messageUid,
                    peerUid: this._user?.uuid,
                    messageType: data.payload.message.type
                });
            }
        }
        this._emitter?.emit(data.type, data.payload);
    }
    async sendViaSocket(action, data) {
        return Promise.resolve(this._socket.write(await new Payload(action, data, this.signature)));
    }
    async sendInRoomViaSocket(action, roomUid, data) {
        return Promise.resolve(this._socket.write({
            request: true,
            id: Math.floor(Math.random() * 1991919),
            type: action,
            room: roomUid,
            sender: this._user?.uuid,
            payload: {
                ...data,
            },
            signature: this.signature,
        }));
    }
    async isConnected() {
        return Promise.resolve(true);
    }
    makeRoomUid(roomUid) {
        return `${this.signature}::${roomUid}`;
    }
    /***
     * Join the room of the chat Server
     * If the roomUid== User.uuid, server joins the spark to all other groups
     * @param {string}roomUid Uuid of the room
     */
    async joinRoom(roomUid) {
        if (!this._user) {
            return;
        }
        const roomData = {
            roomUid: `${this.signature}::${roomUid}`,
            userUid: this._user?.uuid,
        };
        this.sendViaSocket(RoomProtocol.Join, roomData);
    }
    /***
     * Leave the room of the chat Server
     * @param {string}roomUid Uuid of the room
     */
    async leaveRoom(roomUid) {
        if (!this._user) {
            return;
        }
        //Cannot leave the User Room
        if (roomUid.indexOf("::{U}") !== -1) {
            return;
        }
        const roomData = {
            roomUid,
            userUid: this._user?.uuid,
        };
        this.sendViaSocket(RoomProtocol.Leave, roomData);
    }
    /***
     * Delete the room of the chat Server
     * @param {string}roomUid Uuid of the room
     */
    async deleteRoom(roomUid) {
        if (!this._user) {
            return;
        }
        //Cannot leave the User Room
        if (roomUid.indexOf("::{U}") !== -1) {
            return;
        }
        const roomData = {
            roomUid,
            userUid: this._user?.uuid,
        };
        this.sendViaSocket(RoomProtocol.Delete, roomData);
    }
    /***
     * Delete the room of the chat Server
     * @param {string}roomUid Uuid of the room
     */
    async renameRoom(roomUid, newName) {
        if (!this._user) {
            return;
        }
        //Cannot leave the User Room
        if (roomUid.indexOf("::{U}") !== -1) {
            return;
        }
        const roomData = {
            roomUid,
            userUid: this._user?.uuid,
            name: newName
        };
        this.sendViaSocket(RoomProtocol.Rename, roomData);
    }
    /***
     * Kick multiple users from the the room of the chat Server
     * @param {string}roomUid Uuid of the room
     */
    async kickUsersFromRoom(roomUid, peerUids) {
        if (!this._user) {
            return;
        }
        //Cannot leave the User Room
        if (roomUid.indexOf("::{U}") !== -1) {
            return;
        }
        const roomData = {
            roomUid,
            userUid: this._user?.uuid,
            peerUids
        };
        this.sendViaSocket(RoomProtocol.Kick, roomData);
    }
    /***
     * Join the room of the chat Server
     * If the roomUid== User.uuid, server joins the spark to all other groups
     * @param {string}roomUid Uuid of the room
     */
    async fetchMessageHistory(roomUid, lastMessageUid, limit = 20) {
        if (!this._user) {
            return;
        }
        const roomData = {
            roomUid: `${roomUid}`,
            userUid: this._user?.uuid,
            lastMessageUid,
            limit
        };
        this.sendViaSocket(RoomProtocol.TextMessageFetchHistory, roomData);
    }
    /***
     * Invite another user to the group
     * If the roomUid== User.uuid, server joins the spark to all other groups
     * @param {string}requestUid Uuid of the room
     */
    async inviteUser(requestUid, userUid, createNewGroup = false) {
        if (!this._user) {
            return;
        }
        const roomData = {
            requestUid: this.makeRoomUid(requestUid),
            userUid: this._user?.uuid,
            invitee: userUid,
            newGroup: createNewGroup ?? false
        };
        this.sendViaSocket(RoomProtocol.Invite, roomData);
    }
    async getAssociatedRooms() {
        this.sendViaSocket(RoomProtocol.ListRooms, {});
    }
    async sendTextMessageInRoom(roomUid, message) {
        if (!this._user)
            return "";
        const messageRequestId = uuid();
        const roomData = {
            roomUid: roomUid,
            message: {
                messageRequestId,
                type: "TEXT",
                payload: message,
            },
        };
        await this.sendInRoomViaSocket(RoomProtocol.TextMessage, roomData.roomUid, roomData);
        return messageRequestId;
    }
    async sendAttachmentInRoom(roomUid, { filename, key, mime }) {
        if (!this._user)
            return "";
        const messageRequestId = uuid();
        const roomData = {
            roomUid: roomUid,
            message: {
                messageRequestId,
                type: "ATTACHMENT",
                payload: { filename, key, mime },
            },
        };
        await this.sendInRoomViaSocket(RoomProtocol.TextMessage, roomData.roomUid, roomData);
        return messageRequestId;
    }
    async sendStickerInRoom(roomUid, stickerCode) {
        if (!this._user)
            return "";
        const messageRequestId = uuid();
        const roomData = {
            roomUid: roomUid,
            message: {
                messageRequestId,
                type: "STICKER",
                payload: { stickerCode }
            },
        };
        await this.sendInRoomViaSocket(RoomProtocol.TextMessage, roomData.roomUid, roomData);
        return messageRequestId;
    }
    async broadCastTypingEvent(roomUid, typingEventType) {
        if (!this._user)
            return;
        //Check if room is already on call
        const roomData = {
            roomUid: roomUid,
            typingEventType,
        };
        await this.sendInRoomViaSocket(RoomProtocol.TypingEvent, roomData.roomUid, roomData);
    }
    async broadcastMessageSeenEvent(roomUid, messageUid) {
        if (!this._user)
            return;
        //Check if room is already on call
        const roomData = {
            roomUid: roomUid,
            messageUid: messageUid,
            peerUid: this._user.uuid
        };
        await this.sendInRoomViaSocket(RoomProtocol.TextMessageRead, roomData.roomUid, roomData);
    }
    async broadcastMessageReceivedEvent(roomUid, messageUid) {
        if (!this._user)
            return;
        //Check if room is already on call
        const roomData = {
            roomUid: roomUid,
            messageUid: messageUid,
            peerUid: this._user.uuid
        };
        await this.sendInRoomViaSocket(RoomProtocol.TextMessageReceived, roomData.roomUid, roomData);
    }
    async broadcastMessageReactEvent(roomUid, messageUid, reaction) {
        if (!this._user)
            return;
        //Check if room is already on call
        const roomData = {
            roomUid: roomUid,
            messageUid: messageUid,
            peerUid: this._user.uuid,
            reaction,
        };
        await this.sendInRoomViaSocket(RoomProtocol.MessageReact, roomData.roomUid, roomData);
    }
    async startCallInRoom(roomUid, callType) {
        if (!this._user)
            return null;
        if (this._mediaRoomClient)
            return null;
        return new Promise((resolve, reject) => {
            if (this._mediaRoomClient) {
                reject({ err: 'E_BUSY' });
                return;
            }
            var resolver = async (data) => {
                this.off(ChatEvents.CallMediaCheck, resolver);
                if (data.err) {
                    reject({ err: data.err });
                    return;
                }
                const urlParser = new UrlParse(this.wssUrl, true);
                const handlerName = urlParser.query.handlerName || urlParser.query.handler;
                const forceTcp = urlParser.query.forceTcp === "true";
                const produce = true;
                const consume = true;
                const datachannel = true;
                const forceVP8 = urlParser.query.forceVP8 === "true";
                const forceH264 = urlParser.query.forceH264 === "true";
                const forceVP9 = urlParser.query.forceVP9 === "true";
                const enableWebcamLayers = urlParser.query.enableWebcamLayers !== "false";
                const enableSharingLayers = urlParser.query.enableSharingLayers !== "false";
                const webcamScalabilityMode = urlParser.query.webcamScalabilityMode;
                const sharingScalabilityMode = urlParser.query.sharingScalabilityMode;
                const numSimulcastStreams = urlParser.query.numSimulcastStreams
                    ? Number(urlParser.query.numSimulcastStreams)
                    : 3;
                const info = urlParser.query.info === "true";
                const faceDetection = urlParser.query.faceDetection === "true";
                const externalVideo = urlParser.query.externalVideo === "true";
                const throttleSecret = urlParser.query.throttleSecret;
                const e2eKey = urlParser.query.e2eKey;
                const consumerReplicas = urlParser.query.consumerReplicas;
                cookiesManager.setDevices({
                    webcamEnabled: callType == RoomCallType.Audio ? false : true,
                });
                const device = deviceInfo();
                this._mediaRoomClient = new RoomClient({
                    roomId: roomUid,
                    peerId: this._user?.uuid,
                    displayName: this._user?.name,
                    device,
                    handlerName: handlerName,
                    forceTcp,
                    produce,
                    consume,
                    datachannel,
                    forceVP8,
                    forceH264,
                    forceVP9,
                    enableWebcamLayers,
                    enableSharingLayers,
                    webcamScalabilityMode,
                    sharingScalabilityMode,
                    numSimulcastStreams,
                    externalVideo,
                    e2eKey,
                    consumerReplicas: 0,
                    audioOnly: callType == RoomCallType.Audio ? true : false,
                    wssUrl: this.wssUrl,
                });
                await this._mediaRoomClient.join();
                const roomData = {
                    roomUid: roomUid,
                    callType,
                };
                await this.sendInRoomViaSocket(RoomProtocol.StartCall, roomData.roomUid, roomData);
                resolve(this._mediaRoomClient);
            };
            this.on(ChatEvents.CallMediaCheck, resolver);
            this.sendViaSocket(ChatEvents.CallMediaCheck, { roomUid, peerUid: this._user?.uuid });
        });
        //Check if room is already on call
    }
    async activeMediaRoom() {
        return Promise.resolve(this._mediaRoomClient);
    }
    async joinMediaRoom(roomUid, callType) {
        if (this._mediaRoomClient)
            return;
        const urlParser = new UrlParse(this.wssUrl, true);
        let displayName = self.name;
        const handlerName = urlParser.query.handlerName || urlParser.query.handler;
        const forceTcp = urlParser.query.forceTcp === "true";
        const produce = true;
        const consume = true;
        const datachannel = true;
        const forceVP8 = urlParser.query.forceVP8 === "true";
        const forceH264 = urlParser.query.forceH264 === "true";
        const forceVP9 = urlParser.query.forceVP9 === "true";
        const enableWebcamLayers = urlParser.query.enableWebcamLayers !== "false";
        const enableSharingLayers = urlParser.query.enableSharingLayers !== "false";
        const webcamScalabilityMode = urlParser.query.webcamScalabilityMode;
        const sharingScalabilityMode = urlParser.query.sharingScalabilityMode;
        const numSimulcastStreams = urlParser.query.numSimulcastStreams
            ? Number(urlParser.query.numSimulcastStreams)
            : 3;
        const info = urlParser.query.info === "true";
        const faceDetection = urlParser.query.faceDetection === "true";
        const externalVideo = urlParser.query.externalVideo === "true";
        const throttleSecret = urlParser.query.throttleSecret;
        const e2eKey = urlParser.query.e2eKey;
        const consumerReplicas = urlParser.query.consumerReplicas;
        const device = deviceInfo();
        cookiesManager.setDevices({
            webcamEnabled: callType == RoomCallType.Audio ? false : true,
        });
        this._mediaRoomClient = new RoomClient({
            roomId: roomUid,
            peerId: this._user?.uuid,
            displayName: this._user?.name,
            device,
            handlerName: handlerName,
            forceTcp,
            produce,
            consume,
            datachannel,
            forceVP8,
            forceH264,
            forceVP9,
            enableWebcamLayers,
            enableSharingLayers,
            webcamScalabilityMode,
            sharingScalabilityMode,
            numSimulcastStreams,
            externalVideo,
            e2eKey,
            consumerReplicas: 0,
            audioOnly: callType == RoomCallType.Audio ? true : false,
            wssUrl: this.wssUrl,
        });
        await this._mediaRoomClient.join();
        //Have the socket in this media room
        await this.sendViaSocket(ChatEvents.CallJoinMediaRoom, { roomUid });
        await this.sendInRoomViaSocket(ChatEvents.CallEstablished, roomUid, {
            peerUid: this._user?.uuid,
        });
    }
    async endMediaCall(roomUid) {
        if (!this._mediaRoomClient)
            return;
        this._mediaRoomClient.close();
        await this.sendInRoomViaSocket(ChatEvents.CallLeftByUser, this._mediaRoomClient.roomId(), {
            peerUid: this._user?.uuid,
        });
        this._mediaRoomClient = null;
    }
    async declineMediaCall(roomUid) {
        if (this._mediaRoomClient)
            return;
        await this.sendInRoomViaSocket(ChatEvents.CallDeclinedByUser, roomUid, {
            peerUid: this._user?.uuid,
        });
        this._mediaRoomClient = null;
    }
}
